var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list',{attrs:{"nav":"","dense":"","shaped":""}},_vm._l((_vm.dataSource),function(context,idx){return _c('context-tree-view-group',{key:context.Id || 'r' + idx,attrs:{"item":context,"initially-open":false,"itemClick":_vm.itemClick}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }